module.exports = __webpack_public_path__ + "img/404.8f9ee26f.svg";